export const Visibilities = ['PUBLIC', 'PARTNER', 'TRAINER', 'ENTERPRISE_SALES_PARTNER', 'ADVANCED_WEB_IMPLEMENTATION_PARTNER', 'MARKETING_IMPLEMENTATION_PARTNER', 'PARTNER_TYPES_SALES', 'ACADEMY_ONBOARDING'];
export const Difficulties = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED'
};